exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div__AuthContainer {\n  width: 100vw;\n  height: 100vh;\n  /* background-color: var(--WHITE); */\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.h1__AuthContainer {\n  font-size: 33.3px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 0.99;\n  letter-spacing: 8.3px;\n  text-align: center;\n  color: var(--secondary);\n  margin-top:1.5em;\n}\n", ""]);

// exports
